import Vue from "vue";


import Logger from "../../../../shared/logger";
import store from "../../store";
const LOGGER = new Logger(__filename);


export const CODEBASE = 'https://mathcoach.htwsaar.de/js3rdlib/GeoGebra/HTML5/5.0/web3d/';
const MAX_DECIMAL_PLACES = 3;


const PARAMTERS = {
    id: "notSetNow", // wird überschrieben
    width: 800, // wird überschrieben
    height: 600, // wird überschrieben
    // ================================================
    showToolBar: true, // wenn false, dann funktioniert GGB nicht...
    enable3d: true,
    useBrowserForJS: true
    //"showMenuBar": false,
    //"showToolBarHelp": true,
    //"showAlgebraInput": false,
    //"showResetIcon": true,
    //"enableLabelDrags": false,
    //"enableShiftDragZoom": true,
    //"enableRightClick": false,
    //"capturingThreshold": null,
    //"showToolBarHelp": false,
    //"errorDialogsActive": true,
};

const DEBOUNCE_WAIT = 100;

/**
 * stolen from https://davidwalsh.name/javascript-debounce-function
 * @param {*} func 
 * @param {*} wait 
 * @param {*} immediate 
 */
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export const Gfx3dApi = function (idOfDomTarget) {
    const that = this;

    let applet = null;
    let _boardIsReady = false;
    let bus = new Vue();

    function appletOnLoad() {
        LOGGER.log("appletOnLoad");
        applet = window[idOfDomTarget];
        applet.listeners = []; // HACK 
        applet.setPerspective("T");

        applet.registerAddListener(function () {
            LOGGER.log("event AddListener");
            bus.$emit("changed", extractDataFromApplet(applet));
        });
        applet.registerUpdateListener(debounce(() => {
            LOGGER.log("event UpdateListener");
            bus.$emit("changed", extractDataFromApplet(applet));
        }, DEBOUNCE_WAIT));
        bus.$emit("changed", extractDataFromApplet(applet));

        forceOwnLayoutStyle();

        _boardIsReady = true;
        bus.$emit("appletOnLoad");
    }

    function forceOwnLayoutStyle() {
        // Eintellungen überschreiben => GeoGebra soll NUR den 3D-Grafikbereich darstellen
        // applet.setPerspective("T");
        applet.showToolBar(false);
    }

    async function waitForBoardReady() {
        if (_boardIsReady) {
            return Promise.resolve();
        } else {
            return new Promise((res) => {
                bus.$on("appletOnLoad", res);
            });
        }
    }

    that.addChangedListener = function (callback) {
        bus.$on("changed", function () {
            let data = extractDataFromApplet(applet);
            callback(data);
        });
    };

    that.init = async function ({ width, height }) {
        let parameters = {
            ...PARAMTERS,
            id: idOfDomTarget,
            width: width,
            height: height,
            appletOnLoad: appletOnLoad,
        };
        const appletCreator = new GGBApplet(parameters, "5.0"); // eslint-disable-line
        appletCreator.setHTML5Codebase(CODEBASE);
        appletCreator.inject(idOfDomTarget, "preferhtml5");
        await waitForBoardReady();
    };

    that.loadBase64 = async function (base64) {
        await waitForBoardReady(); // wait for board ready
        _boardIsReady = false;
        applet.setBase64(base64);
        await waitForBoardReady();  // wait for board ready again
    };

    that.runScript = async function (script) {
        await waitForBoardReady(); // wait for board ready
        let lineNumber = -1;
        try {
            const blacklist = ["SetPerspective"];
            const lines = script.split("\n");
            for (let i = 0; i < lines.length; i++) {
                lineNumber = i;
                const command = lines[i];
                if (command.trim() !== "") {
                    if (blacklist.some(blacklistedCommand => command.indexOf(blacklistedCommand) > -1)) {
                        throw new Error(`command '${command}' is not allowed`);
                    }
                    LOGGER.log("[GFX3D-SCRIPT]> " + command);
                    let success = applet.evalCommand(command);
                    if (!success) {
                        throw new Error(`can not evaluate command '${command}'`);
                    }
                }
            }
            forceOwnLayoutStyle();
        } catch (error) {
            forceOwnLayoutStyle();
            raiseError({ message: error.message, line: lineNumber });
        }
    };

    function raiseError({ message, line }) {
        bus.$emit("error", { message, line });
    }
    that.addErrorListener = function (callback) {
        bus.$on("error", callback);
    };

    return that;
};



/* ======================================================= */
/* =========== INTERACTION IN GFX3D LAYOUT =============== */
/* ======================================================= */

const BUS = new Vue({});

const EVENT_UPDATE_FORMS = "gfx3d_update_forms";
const EVENT_RUN_SCRIPT = "gfx3d_run_script";

/**
 * Interne Datenstruktur. Sie wird durch `updateData` aktualisiert:
 * - wenn Eingaben im Feedback-Formular durch den Lernenden geändert wurden
 * - wenn der Lerndende Punkte im 3D-Board verschiebt
 */
const DATA = {
    points: [
        /*
        {
            name: "A",
            x: { strValue: "1/2" },
            y: { strValue: "0" },
            z: { strValue: "0" }
        }
        */
    ]
};

/**
 * Aktualisiert das interne Datenmodell. In der Regel stammen die Daten von
 * - einem Feedback-Formular, welches durch den Lernenden verändert wurde
 * - dem Geogebra-Board, welches durch den Lernenden verändert wurde
 * @param {*} data Struktur kompatibel zur `DATA`-Konstante
 */
export const updateData = function (data) {
    DATA.points = data.points;
};

/**
 * Das Datenmodell wird auf das einzig interaktionsfähige Geogebra-Board übertragen.
 */
export const updateBoard = function () {
    let commands = DATA.points
        .map(point => `${point.name} = (${coordinateValueOf(point.x)},${coordinateValueOf(point.y)},${coordinateValueOf(point.z)})`)
        .join("\n");

    doModification({ script: commands });
};

const coordinateValueOf = function (point) {
    let str = point.strValue.replace(",", ".");
    return eval(str);
};

/**
 * Führt ein Script von Geogebra-Commands aus. Um die Geogebra-Komponente wiederverwenden zu 
 * können, ist das Ausführen von Skripten von dieser getrennt (der 'Aufrufer' hat keine direkte Referenz 
 * zu der Geoegebra-Komponente). Mit der `onDoModification` Funktion kann die übergeordnete Komponente den
 * `doModification`-Aufruf über ein Callback an die Geogebra-Komponente 
 * weiterleiten (siehe z.B. im GFX3D-Layout `gfx3d.vue`).
 *  
 * @param {*} modification {
 *  script:"geogebra commands here" | null,
 *  base64:"" | null
 * }
 */
export const doModification = function ({ script, base64 }) {
    BUS.$emit(EVENT_RUN_SCRIPT, { script, base64 });
};
/**
 * Das Callback wird aufgerufen, wenn `doModification` aufgerufen wird.
 * @param {*} callback 
 */
export const onDoModification = function (callback) {
    BUS.$on(EVENT_RUN_SCRIPT, callback);
};

/**
 * Sorgt dafür, dass die Feedback-Formulare sich aktualisieren.
 */
export const updateForms = function () {
    BUS.$emit(EVENT_UPDATE_FORMS, DATA);
};
/**
 * Callback wird aufgerufen, wenn die Feedback-Formulare sich aktualisieren sollen (Aufruf von `updateForms`). 
 * DATA enthält die interne Datenstruktur. Diese sollte nicht direkt verändert werden, sondern 
 * nur über `updateData`.
 * 
 * @param {*} callback function(DATA){...}
 */
export const onUpdateForms = function (callback) {
    BUS.$on(EVENT_UPDATE_FORMS, callback);
};

/**
 * Überträgt das Datenmodell an MathCoach, sodass der Server es auswerten kann.
 */
export const submitData = function () {
    const FEEDBACK_KEY = "gfx3d-feedback"; // see backend
    const payload = {};
    payload.points = DATA.points.map(p => ({
        name: p.name,
        x: coordinateValueOf(p.x),
        y: coordinateValueOf(p.y),
        z: coordinateValueOf(p.z),
    }));
    store.dispatch("sendForm", {
        form: {
            [FEEDBACK_KEY]: JSON.stringify(payload)
        }
    });
};

/* ======================================================= */
/* ======================= UTILS ========================= */
/* ======================================================= */



/**
 * Wandelt die Informationen aus einem Geogebra-Applet in eine interne Datenstruktur um. Diese soll
 * kompatibel zu der `DATA`-Konstante sein.
 * @param {*} ggbApplet 
 */
export const extractDataFromApplet = function (ggbApplet) {
    let result = {};
    window.ggbApplet = ggbApplet;
    result.points = ggbApplet.getAllObjectNames()
        .filter(name => ggbApplet.getObjectType(name) === "point")
        .filter(name => name.indexOf(" ") === -1) // e.g. name="Point (dependent)" 
        .map(name => ({
            name: name,
            x: { strValue: `${parseFloat(ggbApplet.getXcoord(name)).toFixed(MAX_DECIMAL_PLACES)}` },
            y: { strValue: `${parseFloat(ggbApplet.getYcoord(name)).toFixed(MAX_DECIMAL_PLACES)}` },
            z: { strValue: `${parseFloat(ggbApplet.getZcoord(name)).toFixed(MAX_DECIMAL_PLACES)}` },
        }));
    return result;
};
